import { ContentBlock } from "../../types/contentBlock";
import { Slider } from "../../types/slider";
import { AssetQuery } from "./asset";
import { linkQuery } from "./link";

export const sliderQuery = `
    _type == "slider" => {
    ...,
    customContent[] {
        ...,
        image ${AssetQuery},
        title,
        description,
        link {
            ${linkQuery}
        }
    },
    solutions[] -> {
        ...,
        previewImage ${AssetQuery},
        industry -> { title }
    },
    link {
        ${linkQuery}
    }
}`

export const isSlider = (solution: ContentBlock): solution is Slider => {
    return solution._type === 'slider';
}